import dayjs from "dayjs";
import { array, date, mixed, number, object, string } from "yup";

export const StockAdjustmentTypeEnum = Object.freeze({
  ADDITION: "ADDITION",
  DEDUCTION: "DEDUCTION",
});

export const StockAdjustmentTypeLabel = Object.freeze({
  [StockAdjustmentTypeEnum.ADDITION]: "Penambahan",
  [StockAdjustmentTypeEnum.DEDUCTION]: "Pengurangan",
});

export const DEFAULT_VALUES = {
  outlet: null,
  warehouse: null,
  adjustmentChartOfAccount: null,
  transactionDate: dayjs(),
  note: "",
  stockAdjustmentProductVariants: [],
};

export const VALIDATION_SCHEMA = object().shape({
  outlet: object().required("Harus diisi"),
  warehouse: object().required("Harus diisi"),
  adjustmentChartOfAccount: object().nullable().required("Harus diisi"),
  transactionDate: date()
    .required("Harus diisi")
    .max(new Date(), "Tanggal tidak boleh di masa depan"),
  note: string().nullable(),
  stockAdjustmentProductVariants: array()
    .min(1, "Harus memiliki setidaknya satu baris")
    .of(
      object().shape({
        sku: string().required("Harus diisi"),
        type: mixed()
          .oneOf(Object.values(StockAdjustmentTypeEnum))
          .required("Harus diisi"),
        quantity: number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value
          )
          .typeError("Harus berupa angka")
          .required("Harus diisi")
          .moreThan(0, "Harus lebih dari 0"),
        costPerUnit: number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value
          )
          .when("type", {
            is: StockAdjustmentTypeEnum.ADDITION,
            then: (schema) =>
              schema
                .typeError("Harus berupa angka")
                .required("Harus diisi")
                .min(0, "Tidak boleh negatif"),
            otherwise: (schema) => schema.nullable(),
          }),
        note: string().nullable(),
      })
    ),
});
